const noteUserPermissionsEdit = {
  namespaced: true,
  state: {
    isVisible: false,
    // 呼び出し元の種類(edit:ノート編集、select:ノートの選択)
    parentType: ''
  },
  getters: {
  },
  mutations: {
    show(state, parentType) {
      state.parentType = parentType
      state.isVisible = true
    },
    hide(state, parentType) {
      state.parentType = parentType
      state.isVisible = false
    }
  },
  actions: {
    // 閲覧/編集権限付与設定ウィンドウを開く
    show: ({ commit }, parentType) => {
      commit('show', parentType)
    },
    // 閲覧/編集権限付与設定ウィンドウを閉じる
    hide: ({ commit }, parentType) => {
      commit('hide', parentType)
    }
  }
}

export default noteUserPermissionsEdit
